var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("UiButton", {
    attrs: {
      buttonText: _vm.activeButtonText,
      variant: _vm.buttonVariant,
      size: _vm.size,
      processing: _vm.processing,
    },
    nativeOn: {
      click: function ($event) {
        $event.stopPropagation()
        return _vm.handleToggleActiveness.apply(null, arguments)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }